import { foreignIndicatorToLocatedInUS } from '@/utils';

export default {
  CLEAR_ALL: state => {
    state.transaction = {};
    state.healthIdMatch = false;
    state.ssnMatch = false;
    state.similarMembers = [];
    state.fileBoundId = '';
    state.firstName = '';
    state.middleInitial = '';
    state.lastName = '';
    state.suffix = '';
    state.gender = '';
    state.dob = '';
    state.ssn = '';
    state.eyemedId = '';
    state.clientId = '';
    state.groupCk = '';
    state.groupId = '';
    state.groupName = '';
    state.subGroupCk = '';
    state.subGroupId = '';
    state.subGroupName = '';
    state.classId = '';
    state.planId = '';
    state.memberCk = '';
    state.subscriberId = '';
    state.subscriberCk = '';
    state.effectiveDate = '';
    state.termDate = '';
    state.contactInformation = {};
    state.reportingCodes = {
      divisionCode: '',
      benefitOption: '',
      locationCode: '',
      companyCode: '',
      clientGroupNumber: '',
      reportingCode1: '',
      reportingCode2: '',
      reportingCode3: '',
      reportingCode4: '',
      reportingCode5: ''
    };
    state.privacyAddress = {
      foreignIndicator: '',
      firstName: '',
      lastName: '',
      middleInitial: '',
      suffix: '',
      line1: '',
      line2: '',
      line3: '',
      zipCode: '',
      city: '',
      state: '',
      county: '',
      phoneNumber: '',
      emailAddress: ''
    };
    state.languageAssistance = {};
  },
  SET_ADD_FAMILY_CONTEXT(state, selected) {
    console.log('addFamily SET_ADD_FAMILY_CONTEXT', state, selected);
    state.groupId = selected.groupId;
    state.groupName = selected.groupName;
    state.subGroupId = selected.subGroupId;
    state.subGroupName = selected.subGroupName;
  },
  SET_ADD_SUBSCRIBER_TRANSACTION(state, transaction) {
    console.log('addFamily SET_ADD_SUBSCRIBER_TRANSACTION', state, transaction);
    state.transaction = transaction; // helpful for debugging
    state.fileBoundId = transaction.fileBoundId;
    state.firstName = transaction.memberFirstName;
    state.middleInitial = transaction.memberMidInitial;
    state.lastName = transaction.memberLastName;
    state.suffix = transaction.memberNameSuffix;
    state.gender = transaction.gender;
    state.dob = transaction.memberDateOfBirth;
    state.ssn = transaction.ssn;
    state.eyemedId = transaction.eyemedMemberId;
    state.clientId = transaction.clientHealthId;
    state.groupCk = transaction.coverage.groupCk;
    state.groupId = transaction.coverage.groupId;
    state.groupName = transaction.coverage.groupName;
    state.subGroupCk = transaction.coverage.subGroupCk;
    state.subGroupId = transaction.coverage.subGroupId;
    state.subGroupName = transaction.coverage.subGroupName;
    state.classId = transaction.coverage.classId;
    state.planId = transaction.coverage.planId;
    state.relationship = transaction.relationship;
    state.effectiveDate = transaction.coverage.startDate;
    state.termDate = transaction.coverage.endDate;
    state.memberCk = transaction.memberCk;
    state.subscriberCk = transaction.subscriberCk;

    state.reportingCodes = transaction.reportingCodes;
    state.reportingCodes.locationCode =
      transaction.reportingCodes.locationGroupNumber ||
      transaction.reportingCodes.locationCode;
    state.reportingCodes.reportingCode1 =
      state.reportingCodes.reportingCodes[0];
    state.reportingCodes.reportingCode2 =
      state.reportingCodes.reportingCodes[1];
    state.reportingCodes.reportingCode3 =
      state.reportingCodes.reportingCodes[2];
    state.reportingCodes.reportingCode4 =
      state.reportingCodes.reportingCodes[3];
    state.reportingCodes.reportingCode5 =
      state.reportingCodes.reportingCodes[4];

    state.contactInformation = transaction.primaryAddress;
    state.contactInformation.phone = transaction.phone;
    state.contactInformation.email = transaction.email;

    state.privacyAddress = {
      firstName: transaction.privacy.firstName,
      lastName: transaction.privacy.lastName,
      midInitial: transaction.privacy.midInitial,
      suffix: transaction.privacy.suffix,
      line1: transaction.privacy.address.line1,
      line2: transaction.privacy.address.line2,
      line3: transaction.privacy.address.line3,
      zipCode: transaction.privacy.address.zip,
      city: transaction.privacy.address.city,
      state: transaction.privacy.address.state,
      county: transaction.privacy.address.county,
      phoneNumber: transaction.privacy.phone,
      emailAddress: transaction.privacy.email,
      locatedInUS: foreignIndicatorToLocatedInUS(
        transaction.privacy.address.foreignIndicator,
        transaction.privacy.address.locatedInUS
      )
    };

    state.languageAssistance = {
      writtenLanguage: transaction.writtenLanguage
        ? transaction.writtenLanguage.code
        : '',
      spokenLanguage: transaction.spokenLanguage
        ? transaction.spokenLanguage.code
        : '',
      race: transaction.race ? transaction.race.code : '',
      ethnicity: transaction.ethnicity ? transaction.ethnicity.code : ''
    };
  },
  SET_CLASS_ID: (state, classId) => state.classId = classId,
  SET_CLIENT_ID: (state, clientId) => {
    // console.log(`SET_CLIENT_ID`);
    state.clientId = clientId;
  },
  SET_DOB: (state, dob) => state.dob = dob,
  SET_EFFECTIVE_DATE: (state, effectiveDate) => state.effectiveDate = effectiveDate,
  SET_FILE_BOUND_ID: (state, fileBoundId) => state.fileBoundId = fileBoundId,
  SET_FIRST_NAME: (state, firstName) => {
    // console.log(`SET_FIRST_NAME`, firstName);
    state.firstName = firstName
  },
  SET_GENDER: (state, gender) => state.gender = gender,
  SET_GROUP_CK(state, groupCk) {
    // console.log('addFamily SET_GROUP_CK', state, groupCk);
    state.groupCk = groupCk;
  },
  SET_GROUP_NAME(state, groupName) {
    // console.log('addFamily SET_GROUP_NAME', state, groupName);
    state.groupName = groupName;
  },
  SET_HEALTH_ID_MATCH: (state, healthIdMatch) => (state.healthIdMatch = healthIdMatch),
  SET_LAST_NAME: (state, lastName) => state.lastName = lastName,
  SET_MEMBER_CK(state, memberCk) {
    // console.log('addFamily SET_MEMBER_CK', state, memberCk);
    state.memberCk = memberCk;
  },
  SET_MIDDLE_INITIAL: (state, middleInitial) => state.middleInitial = middleInitial,
  SET_PLAN_ID: (state, planId) => state.planId = planId,
  SET_SIMILAR_MEMBERS(state, members) {
    // console.log('addFamily SET_SIMILAR_MEMBERS', state, members);
    if (!Array.isArray(members)) {
      console.warn('unable to set SET_SIMILAR_MEMBERS, value is not an array');
      return;
    }
    state.similarMembers = members;
  },
  SET_SSN: (state, ssn) => (state.ssn = ssn),
  SET_SSN_MATCH: (state, ssnMatch) => (state.ssnMatch = ssnMatch),
  SET_SUB_GROUP_CK(state, subGroupCk) {
    // console.log('addFamily SET_SUB_GROUP_CK', state, subGroupCk);
    state.subGroupCk = subGroupCk;
  },
  SET_SUBSCRIBER: (state, subscriber) => (state.subscriber = subscriber),
  SET_SUBSCRIBER_ID(state, subscriberId) {
    // console.log('addFamily SET_SUBSCRIBER_ID', state, subscriberId);
    state.subscriberId = subscriberId;
  },
  SET_SUBSCRIBER_CK(state, subscriberCk) {
    // console.log('addFamily SET_SUBSCRIBER_CK', state, subscriberCk);
    state.subscriberCk = subscriberCk;
  },
  SET_SUFFIX: (state, suffix) => state.suffix = suffix,
  SET_TERM_DATE: (state, termDate) => state.termDate = termDate, 
}
